export default {
  "config": {
    "trial": "tones-3",
    "id": "bp-hr",
    "type": "table",
    "title": "Blood Pressure and Heart Rate by <no-break>24 h</no-break> Ambulatory Monitoring: Mean Change <no-break>(95% CI)</no-break> From Baseline to <no-break>Week 8<sup>7</sup></no-break>",
    "footnotes": [
      "<sup>a</sup>Number of participants who had ≥50% valid ABPM readings."
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-3",
    "id": "bp-hr",
    "data-type": "table",
    "title": "Blood Pressure and Heart Rate by <no-break>24 h</no-break> Ambulatory Monitoring: Mean Change <no-break>(95% CI)</no-break> From Baseline to <no-break>Week 8<sup>7</sup></no-break>",
    "num-header-rows": 1,
    "num-columns": 5,
    "col-classes": [
      "col-1",
      "pbo",
      "sol-375",
      "sol-75",
      "sol-150"
    ],
    "row-mergeoption": [
      1
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-a"
    ],
    "footnote-a": "<sup>a</sup>Number of participants who had ≥50% valid ABPM readings.",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Placebo</b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol<br><no-break>37.5 mg</no-break></b>",
          "cols": 1,
          "class": "sol-375"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol<br><no-break>75 mg</no-break></b>",
          "cols": 1,
          "class": "sol-75"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol<br><no-break>150 mg</no-break></b>",
          "cols": 1,
          "class": "sol-150"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "n<sup>a</sup>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 92,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": 43,
          "cols": 1,
          "class": "sol-375"
        },
        {
          "indent": 0,
          "content": 49,
          "cols": 1,
          "class": "sol-75"
        },
        {
          "indent": 0,
          "content": 96,
          "cols": 1,
          "class": "sol-150"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "SBP",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.2</no-break> <no-break>(–1.8</no-break>, 1.4)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1.8 <no-break>(–1.1</no-break>, 4.6)",
          "cols": 1,
          "class": "sol-375"
        },
        {
          "indent": 0,
          "content": "2.6 (0.02, 5.3)",
          "cols": 1,
          "class": "sol-75"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.2</no-break> <no-break>(–2.0</no-break>, 1.6)",
          "cols": 1,
          "class": "sol-150"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "DBP",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "0.2 <no-break>(–0.9</no-break>, 1.3)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1.4 <no-break>(–0.4</no-break>, 3.2)",
          "cols": 1,
          "class": "sol-375"
        },
        {
          "indent": 0,
          "content": "1.5 <no-break>(–0.04</no-break>, 3.1)",
          "cols": 1,
          "class": "sol-75"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.1</no-break> <no-break>(–1.1</no-break>, 1.0)",
          "cols": 1,
          "class": "sol-150"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "HR",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<no-break>–0.4</no-break> <no-break>(–1.7</no-break>, 0.9)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "0.4 <no-break>(–1.4</no-break>, 2.2)",
          "cols": 1,
          "class": "sol-375"
        },
        {
          "indent": 0,
          "content": "1.0 <no-break>(–0.9</no-break>, 2.81)",
          "cols": 1,
          "class": "sol-75"
        },
        {
          "indent": 0,
          "content": "1.7 (0.5, 2.9)",
          "cols": 1,
          "class": "sol-150"
        }
      ]
    }
  }
};